unit Web.Search.Utils;

interface

uses
  Web.StringUtils;

type
  TSearchContainsField = record
    FieldName: string;
    MaxLength: Integer;

    class function Create(const AFieldName: string; AMaxLength: Integer): TSearchContainsField; static;
  end;

/// <summary>
///  Build OData filter text for list search (school/academy list pages).
/// </summary>
function BuildListSearchFilter(const ARawValue: string;
  const AContainsFields: array of TSearchContainsField;
  AIncludeExternalIdEqInAlpha: Boolean;
  AExternalIdMaxLen: Integer;
  AIncludeExternalIdEqInNumeric: Boolean): string;

function BuildInvoiceListFilter(AExcludePaid: Boolean): string;

function BuildODataIntegerEqFilter(const AFieldName: string; AId: Integer): string;

function BuildODataEqFilter(const AFieldName, AValue: string): string;

function BuildODataIntegerEqFilterWithOrderBy(const AFieldName: string; AId: Integer;
  const AOrderBy: string): string;

implementation

uses
  System.SysUtils;

class function TSearchContainsField.Create(const AFieldName: string; AMaxLength: Integer): TSearchContainsField;
begin
  Result.FieldName := AFieldName;
  Result.MaxLength := AMaxLength;

end;

function BuildListSearchFilter(const ARawValue: string;
  const AContainsFields: array of TSearchContainsField;
  AIncludeExternalIdEqInAlpha: Boolean;
  AExternalIdMaxLen: Integer;
  AIncludeExternalIdEqInNumeric: Boolean): string;
var
  iIdx: Integer;
  sEscaped: string;
  sPart: string;

begin
  sEscaped := EscapeSingleQuotesFirebird(UpperCase(Trim(ARawValue)));

  if ContainsAlpha(ARawValue) then
  begin
    Result := '';

    for iIdx := Low(AContainsFields) to High(AContainsFields) do
    begin
      if Result <> '' then
        Result := Result + ' or ';

      sPart := Copy(sEscaped, 1, AContainsFields[iIdx].MaxLength);

      Result := Result + 'contains(upper(' + AContainsFields[iIdx].FieldName + '), ''' + sPart + ''')';

    end;

    if AIncludeExternalIdEqInAlpha then
    begin
      if Result <> '' then
        Result := Result + ' or ';

      Result := Result + 'upper(ExternalId) eq ''' + Copy(sEscaped, 1, AExternalIdMaxLen) + '''';

    end;

  end
  else
  begin
    Result := '';

    if AIncludeExternalIdEqInNumeric then
    begin
      Result := 'upper(ExternalId) eq ''' + Copy(sEscaped, 1, AExternalIdMaxLen) + '''';
      Result := Result + ' or ';

    end;

    Result := Result + 'Id eq ''' + sEscaped + '''';

  end;

end;

function BuildInvoiceListFilter(AExcludePaid: Boolean): string;
begin
  if AExcludePaid then
    Result := '$filter= PaidInFull ne true'
  else
    Result := '';

end;

function BuildODataIntegerEqFilter(const AFieldName: string; AId: Integer): string;
begin
  Result := '$filter= ' + AFieldName + ' eq ' + IntToStr(AId);

end;

function BuildODataEqFilter(const AFieldName, AValue: string): string;
begin
  Result := '$filter= ' + AFieldName + ' eq ' + AValue;

end;

function BuildODataIntegerEqFilterWithOrderBy(const AFieldName: string; AId: Integer;
  const AOrderBy: string): string;
begin
  Result := BuildODataIntegerEqFilter(AFieldName, AId) + ' &$orderBy=' + AOrderBy;

end;

end.
